import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { PasswordField } from '@anytag/shared-molecules';
import { Anchor, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { TikTokPasswordFormValues, TikTokPasswordFormKeys } from './types';

export const Template = () => {
  const { t } = useTranslation();
  const {
    watch,
    formState: { isSubmitting }
  } = useFormContext<TikTokPasswordFormValues>();

  const values = watch();

  return (
    <Form.Body className="px-0 py-12">
      <div className="mx-auto my-0 w-107 px-10">
        <PasswordField<TikTokPasswordFormKeys> name="password" title={t('Password.Password')} dynamicError required />
        <PasswordField<TikTokPasswordFormKeys> name="passwordConfirm" title={t('Password.Confirm Password')} required />

        <ButtonSubmit
          variant="solid"
          loading={isSubmitting}
          className="mt-4 w-full"
          title={t('Button.Sign Up')}
          disabled={!values.password || !values.passwordConfirm}
        />
      </div>

      <p className="mt-8 text-center text-[11px] leading-[140%] text-tertiary">
        <Trans
          i18nKey="SignInConfirmation"
          components={{
            a1: <Anchor variant="blue" css={{ display: 'inline', lineHeight: 'inherit' }} to="/privacy" />,
            a2: <Anchor variant="blue" css={{ display: 'inline', lineHeight: 'inherit' }} to="/terms" />
          }}
        />
      </p>
    </Form.Body>
  );
};
